<div class="parent" [formGroup]="parentForm">
	<div formGroupName="{{nestedFormGroupName}}">
		<label>{{ (isUpperJaw ? 'Upper jaw' : 'Lower jaw') | translate}}</label>
		<div formGroupName="{{jawFormControlName}}">
			<mat-radio-group formControlName="option">
				<mat-radio-button value="{{AnswerOption.KEEP}}">{{ AnswerOption.KEEP | translate}}</mat-radio-button>
				<mat-radio-button value="{{AnswerOption.OPPOSITE_JAW}}">
					{{ AnswerOption.OPPOSITE_JAW | translate: {jaw: (!isUpperJaw ? 'UJ' : 'LJ') | translate} }}
				</mat-radio-button>
				<div>
					<mat-form-field>
						<input matInput formControlName="text">
						<mat-error>{{"please fill in" | translate}}</mat-error>
					</mat-form-field>
					<label>{{'mm to the' | translate }} </label>
					<mat-radio-button value="{{AnswerOption.LEFT}}">{{ AnswerOption.LEFT | translate}}</mat-radio-button>
					<mat-radio-button value="{{AnswerOption.RIGHT}}">{{ AnswerOption.RIGHT | translate}}</mat-radio-button>
				</div>
			</mat-radio-group>
		</div>
	</div>
</div>
